import { jsx as a } from "../../_virtual/jsx-runtime.mjs";
import * as o from "react";
import n from "./ReoButton.mjs";
import r from "../../depend/classnames/index.mjs";
import { useOmitProps as c } from "../../hook/useOmitProps.mjs";
import "../ReoForm/context/FormItemInputContext.mjs";
import "../ReoForm/context/ReoFormCompContext.mjs";
import { baseButtonAnimateProps as l } from "./const.mjs";
import { reoButtonAnimate as u, btnWrapClass as d } from "./css/ReoButtonAnimate.mjs";
const f = o.forwardRef((t, e) => {
  const s = c(t, l), m = o.useMemo(() => r(
    u,
    t.className
  ), [t.className]), i = o.useMemo(() => r(
    d,
    t.buttonWrapClass
  ), [t.buttonWrapClass]);
  return o.useMemo(
    () => t.iconPosition === "left" && !t.children,
    [t.children, t.iconPosition]
  ) ? /* @__PURE__ */ a(
    "div",
    {
      className: i,
      children: /* @__PURE__ */ a(
        n,
        {
          ref: e,
          className: m,
          ...s
        }
      )
    }
  ) : /* @__PURE__ */ a(
    n,
    {
      ref: e,
      className: m,
      ...s
    }
  );
});
f.displayName = "ReoButtonAnimate";
export {
  f as default
};
//# sourceMappingURL=ReoButtonAnimate.mjs.map
